import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Conoce al Equipo</h2>
          <p>
            {/* Soy Lucas Ezequiel Martínez Bogado, Ingeniero de Sistemas egresado de la Universidad Nacional del Este, Facultad Politécnica.
            Cuento con más de 4 años de experiencia en el desarrollo de software, creando soluciones eficientes, escalables e innovadoras para empresas de distintos sectores.
            Mi enfoque está en la optimización de procesos, automatización y desarrollo de sistemas personalizados que impulsan el crecimiento de negocios a través de la tecnología utilizando las mejores herramientas. */}
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-12 col-sm-12 team">
                <div className="thumbnail">
                  {" "}
                  <img src={d.img} alt="..." className="team-img" />
                  <div className="caption">
                    <h4>{d.name}</h4>
                    <p>{d.job}</p>
                  </div>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
